import { MyAgentsData } from '@/components/rightPanel/subpanel/agents/myAgents/MyAgents';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../../components/rightPanel/subpanel/developerKey/DeveloperKey';

interface AgentActivationProcess {
  ShowAgentActivationDialogOnChat: boolean;
  activationAgent: MyAgentsData;
}

interface AgentSharedUsers {
  users: UserDetails[];
}

interface AgentsState {
  activeAgent: MyAgentsData;
  agentActivationProcess: AgentActivationProcess;
  agentSharedUsers: AgentSharedUsers;
  updateAgentDetails: MyAgentsData;
  isAgentToBeUpdated: boolean;
  refetchAgentsList: boolean;
  isAgentView: boolean;
  isAgentOwner: boolean;
  selectedAgentsTabForViewAll: string;
}

const agentsInitialState = (): MyAgentsData => ({
  name: '',
  _id: '',
  description: '',
  model_name: '',
  temperature: 0.3,
  max_output_tokens: null,
  instructions: '',
  tools: null,
  dataset_id: null,
  type: '',
  owners: [],
  acl: { users: [] },
});

const initialState: AgentsState = {
  activeAgent: agentsInitialState(),
  agentActivationProcess: {
    ShowAgentActivationDialogOnChat: false,
    activationAgent: agentsInitialState(),
  },
  agentSharedUsers: {
    users: [],
  },
  updateAgentDetails: agentsInitialState(),
  isAgentToBeUpdated: false,
  refetchAgentsList: false,
  isAgentView: false,
  isAgentOwner: false,
  selectedAgentsTabForViewAll: '',
};

export const agentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    activeAgentMethod: (state, action: PayloadAction<MyAgentsData>) => {
      state.activeAgent = action.payload;
    },
    agentActivationMethod: (state, action: PayloadAction<AgentActivationProcess>) => {
      state.agentActivationProcess = action.payload;
    },
    agentSharedUsers: (state, action: PayloadAction<AgentSharedUsers>) => {
      state.agentSharedUsers = action.payload;
    },
    updateAgent: (state, action: PayloadAction<MyAgentsData>) => {
      state.updateAgentDetails = action.payload;
    },
    confirmAgentUpdate: (state, action: PayloadAction<boolean>) => {
      state.isAgentToBeUpdated = action.payload;
    },
    refreshAgentsList: (state, action: PayloadAction<boolean>) => {
      state.refetchAgentsList = action.payload;
    },
    resetActiveAgent: () => ({ ...initialState, activeAgent: agentsInitialState() }),
    resetAgentActivationProcess: () => ({
      ...initialState,
      agentActivationProcess: {
        ShowAgentActivationDialogOnChat: false,
        activationAgent: agentsInitialState(),
      },
    }),
    resetUpdateAgentDetails: () => ({ ...initialState, updateAgentDetails: agentsInitialState() }),
    setIsAgentView: (state, action: PayloadAction<boolean>) => {
      state.isAgentView = action.payload;
    },
    setIsAgentOwner: (state, action: PayloadAction<boolean>) => {
      state.isAgentOwner = action.payload;
    },
    setSelectedAgentsTabForViewAll: (state, action: PayloadAction<string>) => {
      state.selectedAgentsTabForViewAll = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  activeAgentMethod,
  agentActivationMethod,
  agentSharedUsers,
  updateAgent,
  confirmAgentUpdate,
  refreshAgentsList,
  resetActiveAgent,
  resetAgentActivationProcess,
  resetUpdateAgentDetails,
  setIsAgentOwner,
  setIsAgentView,
  setSelectedAgentsTabForViewAll,
} = agentsSlice.actions;

export default agentsSlice.reducer;
